import VacancySettingsInformation from './VacancySettingsInformation.component';

export default VacancySettingsInformation;